export const blueButtonClass: string = "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md shadow-md focus:outline-none focus:ring focus:ring-blue-300";
export const redButtonClass: string = "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-md shadow-md focus:outline-none focus:ring focus:ring-red-300";
export const greenButtonClass: string = "bg-green-700 hover:bg-green-900 text-white font-bold py-2 px-4 rounded-md shadow-md focus:outline-none focus:ring focus:ring-green-500";
export const h1Class: string = "text-4xl md:text-6xl font-bold text-center text-green-700";
export const h2Class: string = "text-2xl md:text-4xl font-bold text-center text-blue-500";
export const inputClass: string = "border border-gray-500 rounded-md px-1 my-1";
export const modalStyle: object = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        borderRadius: '10px',
    },
};
